"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_datepicker_1 = __importDefault(require("react-datepicker"));

var react_web_components_1 = require("@nimles/react-web-components");

var DateTimeInput = function DateTimeInput(_a) {
  var field = _a.field,
      _b = _a.form,
      errors = _b.errors,
      setFieldValue = _b.setFieldValue,
      required = _a.required,
      info = _a.info,
      label = _a.label;
  return react_1.default.createElement("div", {
    key: field.name
  }, label ? react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label) : null, react_1.default.createElement("div", null, react_1.default.createElement(react_datepicker_1.default, {
    selected: field.value ? new Date(field.value) : undefined,
    onChange: function onChange(date) {
      return setFieldValue(field.name, date && date.toISOString);
    }
  }), react_1.default.createElement("div", null, errors && errors[field.name])), react_1.default.createElement("div", null, react_1.default.createElement("img", {
    style: {
      height: 100
    },
    src: field.value,
    alt: ""
  })));
};

exports.DateTimeField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: DateTimeInput
  }));
};